import React, { createContext, useContext, useEffect, useState } from 'react';

const VerifiedDBContext = createContext(null);

export const useVerifiedDB = () => {
  const ctx = useContext(VerifiedDBContext);
  if (!ctx) throw new Error('useVerifiedDB must be used within VerifiedDBProvider');
  return ctx;
};

const STORAGE_KEY = 'ac_verified_records_v1';

export const VerifiedDBProvider = ({ children }) => {
  const [records, setRecords] = useState(() => {
    try { const raw = localStorage.getItem(STORAGE_KEY); return raw ? JSON.parse(raw) : []; } catch { return []; }
  });

  useEffect(() => { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(records)); } catch {} }, [records]);

  const genId = () => {
    try {
      if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch {}
    return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  };
  const addRecord = (rec) => setRecords((prev) => [...prev, { id: genId(), ...rec }]);
  const addRecords = (list) => setRecords((prev) => [...prev, ...list]);
  const findByHash = (hash) => {
    const target = (hash || '')?.toString().trim().toLowerCase();
    if (!target) return undefined;
    return records.find(r => {
      const h = (r.fileHash || r.file_hash || '')?.toString().trim().toLowerCase();
      return !!h && h === target;
    });
  };
  const findByRollOrCertId = (id) => records.find(r => r.roll_number === id || r.certificate_id === id);

  const value = { records, addRecord, addRecords, findByHash, findByRollOrCertId };
  return <VerifiedDBContext.Provider value={value}>{children}</VerifiedDBContext.Provider>;
};

export default VerifiedDBContext;
